"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Loader, CircleCheck } from "lucide-react";
export default function CustomQuoteForm() {
  return <section id="customquoteform" className="py-16 px-4 bg-background">
      <div className="max-w-2xl mx-auto">
        <FormProvider className="w-full" formId="request_quote_form_pricing" sectionName="custom-quote-form" defaultValues={{
        name: "",
        email: "",
        phone: "",
        event_date: "",
        event_type: "",
        estimated_guests: "",
        additional_details: ""
      }} validationRules={{
        name: {
          required: true,
          minLength: 2,
          maxLength: 50
        },
        email: {
          required: true,
          pattern: "email"
        },
        phone: {
          required: true
        },
        event_date: {
          required: true
        },
        event_type: {
          required: true
        },
        estimated_guests: {
          min: 1
        },
        additional_details: {}
      }} submitText="Request Quote" successMessage="Thank you! We'll get back to you soon with a custom quote tailored to your event." errorMessage="Failed to submit your request. Please try again or contact us directly.">
          <QuoteFormContent />
        </FormProvider>
      </div>
    </section>;
}
function QuoteFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <Card className="bg-primary-light border-primary shadow-soft">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center gap-4 text-center">
            <CircleCheck className="size-12 text-primary-dark" />
            <div>
              <h3 className="text-xl font-display font-semibold text-primary-dark mb-2">Quote Request Received!</h3>
              <p className="text-foreground">{successMessage}</p>
            </div>
            <Button onClick={resetForm} variant="outline" className="mt-2">
              Submit Another Request
            </Button>
          </div>
        </CardContent>
      </Card>;
  }
  return <Card className="shadow-medium border-border">
      <CardHeader>
        <CardTitle className="text-3xl font-display text-primary-dark">Event Coordination Pricing</CardTitle>
        <CardDescription className="text-base">Coming soon!</CardDescription>
      </CardHeader>
      
      <CardContent>
        <Form onSubmit={handleSubmit}>
          
        </Form>
      </CardContent>
    </Card>;
}